import { render } from "./app-menu-primary.vue?vue&type=template&id=b575b4c6&scoped=true"
import script from "./app-menu-primary.vue?vue&type=script&lang=js"
export * from "./app-menu-primary.vue?vue&type=script&lang=js"

import "./app-menu-primary.vue?vue&type=style&index=0&id=b575b4c6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b575b4c6"]])

export default __exports__